import PersoneIcon from "./PersoneIcon";
import ImageCaption from "./ImageCaption";
import { useEffect } from "react";
import GalleryImages from "./GalleryImages";


const transformData = (data) => {
    return data.map(item => ({
        src: item.src,
        alt: item.alt,
        caption: item.caption, 
    }));
};

const GalleryPublication = ({ styles, theme, gallery, image_caption }) => {
    
    const images = transformData(gallery);
    useEffect(() => {
        document.body.setAttribute("data-theme", theme);
        return () => {
            document.body.removeAttribute("data-theme");
        };
    }, [theme]);
    return (
        <div id="gallery-publication" className={"galleryPublication"}>
            <section className={` galleryWrapper ${images?.length === 3 ? `galleryWrappercolthree` : (images?.length === 2) ? `galleryWrappercolTwo` : images?.length === 1 ? `galleryWrappercolOne` : (images?.length === 4) && `wrapperColTwo` }`}>
                <GalleryImages images={images} theme={theme}/>
                {! image_caption && 
                    <div className="corner-bottom-right bottom">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                        </svg>
                    </div>
                }
            </section>
            <PersoneIcon theme={theme}/>
            {image_caption &&
                <ImageCaption caption={image_caption} />
            }
        </div>
    );
};

export default GalleryPublication;